module.exports = __webpack_public_path__ + "img/logo-o.e8793787.png";